import React from 'react';
import { Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
// import './App.css';
import './stylesheets/main.scss';
import Layout from './pages/Layout';
import Home from './pages/Home';
import Register from './pages/Register';
import Login from './pages/Login';
import ForgetPassword from './pages/ForgetPassword';
import ResetPassword from './pages/ResetPassword';
import Payment from './pages/Payment';
import Verification from './pages/Verification';
import Activity from './pages/Activity';
import ActivityDetail from './pages/ActivityDetail';
import Announcements from './pages/Announcements';
import AnnouncementDetail from './pages/AnnouncementDetail';
import Notices from './pages/Notices';
import NoticeDetail from './pages/NoticeDetail';
import Batteries from './pages/Batteries';
import MemberProfile from './pages/MemberProfile';
import PrivateRoute from './components/PrivateRoute'; // 引入 PrivateRoute 組件

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgetpwd" element={<ForgetPassword />} />
        <Route path="q/:resetHash" element={<ResetPassword />} />
        {/* <Route path="/resetpwd/:resetHash" element={<ResetPassword />} /> */}
        <Route path="/payment/:batteryId" element={
          <PrivateRoute>
            <Payment />
          </PrivateRoute>
        } />
        <Route path="/verification" element={<Verification />} />
        <Route path="/activity" element={<Activity />} />
        <Route path="/activity/:activityId" element={<ActivityDetail />} />
        <Route path="/battery" element={
          <PrivateRoute>
            <Batteries />
          </PrivateRoute>
        } />
        <Route path="/announcement" element={
          <PrivateRoute>
            <Announcements />
          </PrivateRoute>
        } />
        <Route path="/announcement/:announcementId" element={
          <PrivateRoute>
            <AnnouncementDetail />
          </PrivateRoute>
        } />
        <Route path="/notice" element={
          <PrivateRoute>
            <Notices />
          </PrivateRoute>
        } />
        <Route path="/notice/:noticeId" element={
          <PrivateRoute>
            <NoticeDetail/>
          </PrivateRoute>
        } />
        <Route path="/member/profile" element={
          <PrivateRoute>
            <MemberProfile />
          </PrivateRoute>
        } />
      </Route>
    </Routes>
  );
};

export default App;
